import { PageList as SalesPage } from "./Sales";

export const PageList = () => {
  return <SalesPage />;
};

export { PageList as Sales } from './Sales';
export { ClientPurchases } from './ClientPurchases';
export { Receipt } from './Receipt';
export { ReceiptView } from './ReceiptView';
